import axios from "axios";

import {
  setupInterceptors,
} from "./interceptors";

const httpClient = axios.create({
  baseURL: import.meta.env.VITE_SERVER_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
  responseType: "json",
});

setupInterceptors(httpClient);

export default httpClient;
